import { render, staticRenderFns } from "./Resubmission.vue?vue&type=template&id=795e6968"
import script from "./Resubmission.vue?vue&type=script&lang=js"
export * from "./Resubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports